<template>
	<AppDialog :closeRight="'-10'" :closeTop="'-30'" disableMaxWidth :dialogName="'CommandBarShortcut'" width="850px">
		<div class="dialog-content rounded width-100 flex-column flex-centerize">
			<div v-if="isLoading" class="width-100 height-100 flex-centerize">
				<AppLoader size="18px" />
			</div>
			<iframe v-show="!isLoading" class="rounded width-100 height-100" :src="iframeUrl" @load="isLoading = false" />
		</div>
	</AppDialog>
</template>

<script>
import AppDialog from '@/components/dialogs/AppDialog/AppDialog.vue';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
export default {
	name: 'ListingDetailsDialog',
	components: {
		AppDialog,
	},
	props: {
		listing: { type: Object },
		dialogPromiseHandlers: { type: Object },
	},
	computed: {
		iframeUrl() {
			return `https://ply.io/marketplace/builder/listing/${this.listing.listing_slug}/${this.listing.id}/`;
		},
	},
	methods: {
		close() {
			this.dialogPromiseHandlers.resolve();
			AppDialogManagerService.closeCurrentDialog();
		},
		openInstallationDialog() {
			this.removeMessageListener();
			this.close();
			AppDialogManagerService.openInstallationDialog({
				installableId: this.listing.id,
				installableVersionId: this.listing.current_version,
			});
		},
		onMessage(event) {
			const data = event.data;
			if (!data) {
				return;
			}
			if (data.eventType === 'INSTALL_STARTED') {
				this.openInstallationDialog();
			}
		},
		removeMessageListener() {
			if (this.messageHandler) {
				window.removeEventListener('message', this.messageHandler, true);
				this.messageHandler = null;
			}
		},
		listenOnMessage() {
			this.removeMessageListener();
			this.messageHandler = (e) => this.onMessage(e);
			window.addEventListener('message', this.messageHandler, true);
		},
	},
	mounted() {
		this.listenOnMessage();
	},
	beforeDestroy() {
		this.removeMessageListener();
	},
	data() {
		return {
			isLoading: true,
			messageHandler: null,
		};
	},
};
</script>

<style scoped lang="scss">
.dialog-content {
	height: 90vh;
	background: var(--white);
	box-shadow: 0px 3px 6px #00000029;
}

.rounded {
	border-radius: 10px;
}
</style>
